import { Injectable } from '@angular/core';
import { openDB, IDBPDatabase, deleteDB } from 'idb';
import { Subject } from 'rxjs';

import { RepositoriesConfig } from '../core/utils/repositories.config';

@Injectable({
    providedIn: 'root'
})
export class RepositoryService {
    databaseSubject = new Subject<IDBPDatabase<unknown>>();
    async setup(): Promise<void> {
        const databaseName = 'thumedi-idb';
        const databaseVersion = 2;
        const database = await openDB(databaseName, databaseVersion, {
            upgrade(db, oldVersion, newVersion, transaction) {
                if (oldVersion === 0) {
                    RepositoriesConfig.repositories.forEach(repo => {
                        const store = db.createObjectStore(repo.tableName, {
                            keyPath: repo.keyPath,
                            autoIncrement: repo.autoIncrement
                        });
                        if (repo.index) {
                            store.createIndex(repo.index, repo.index, {
                                unique: repo.isIndexUnique
                            });
                        }
                    });
                }
                if (oldVersion === 1) {
                    const objects = db.objectStoreNames;
                    RepositoriesConfig.repositories.forEach(repo => {
                        if (!objects.contains(repo.tableName)) {
                            const store = db.createObjectStore(repo.tableName, {
                                keyPath: repo.keyPath,
                                autoIncrement: repo.autoIncrement
                            });

                            if (repo.index) {
                                store.createIndex(repo.index, repo.index, {
                                    unique: repo.isIndexUnique
                                });
                            }
                        }
                    });
                }
            }
        });
        this.databaseSubject.next(database);
    }

    async delete(): Promise<void> {
        const databaseName = 'thumedi-idb';
        try {
            await deleteDB(databaseName);

            this.databaseSubject.next(null);
        } catch (err) {
            // Handle the error in case the database doesn't exists
            console.log(err);
        }
    }
}
